import { createMakeStyles } from 'tss-react';
import { type V3Theme, v3 } from './theme';

const { makeStyles } = createMakeStyles<V3Theme>({
  useTheme: () => v3,
});

export { makeStyles };
